import { useInvoiceCentralLayoutContext } from '@/enterprise/components/InvoiceCentral/InvoiceCentralLayout';
import { AdjustmentsView } from '@/enterprise/features/invoiceTables/adjustments';
import useFeature from '@/lib/features';
import { useReporting } from '@/reporting';
import useDataDog from '@/reporting/DataDog';

/**
 * Invoice Central adjustments tab — thin host over the shared SEA adjustment-invoice view.
 * Filter-bar download (all / filtered SEA CSV) is owned by AdjustmentsView.
 */
const Adjustments = () => {
  const { addAction } = useDataDog();
  const { trackEnterpriseEvent } = useReporting();
  const [invoiceApiMigrationEnabled] = useFeature('enterprise-ui_invoiceApiMigration');
  const {
    buyer,
    urlParams: { makerOrganizationUuid, currency },
  } = useInvoiceCentralLayoutContext();
  const { takerMarkets } = buyer;

  return (
    <AdjustmentsView
      source={{
        makerOrganizationUuid,
        makerOrganizationName: buyer.makerOrganizationName,
        currency,
        takerMarkets,
      }}
      actions={{
        enableFilterBarDownload: invoiceApiMigrationEnabled,
        onDownloadSubmitted: ({ scope }) => {
          trackEnterpriseEvent('invoice-central::download-invoices::submitted', {
            invoiceType: 'adjustments',
            downloadScope: scope,
            takerMarketIds: takerMarkets.map((tm) => ({
              takerId: tm.takerDivisionId,
              marketId: tm.legacyMarketId,
            })),
          });
        },
        onSearch: () => {
          addAction('invoice-central::invoices-searched', {
            invoiceType: 'adjustment',
            makerOrganizationUuid,
            currency,
          });
        },
        onSort: ({ sortKey, sortDirection }) => {
          addAction('invoice-central::invoices-sorted', {
            invoiceType: 'adjustment',
            sortKey,
            sortDirection,
            makerOrganizationUuid,
            currency,
          });
        },
        onFiltersChange: ({ filterKeys }) => {
          addAction('invoice-central::invoices-filtered', {
            invoiceType: 'adjustment',
            makerOrganizationUuid,
            currency,
            filters: filterKeys,
          });
        },
      }}
    />
  );
};

export default Adjustments;
